module.exports = __webpack_public_path__ + "static/media/matplotlib.ddcbe2d3.png";